<template>
<div>
  <Banner title="Crosslink"
	  pricing="true"
	  level="5"
	  bg-color="#fff"
	  class="sticky-top" />
  
  
  
  <SectionDivider bg-color="#ffb300" />

  
    
  <Layout09 />
  
  
  
  <b-container
    style="background-color: #ffb300; 
	   font-family: Arial, Helvetica, sans-serif; 
	   font-size: 1.2rem;"
    fluid
    >
    <b-row class="text-center">
      <b-col cols="12" lg="4">
	<b-button
	  size="lg"
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('unique')"
	  >
	  <span class="link-ref-text">Unique to Graphmetrix</span>
	</b-button>
      </b-col>
      <b-col cols="12" lg="4">
	<b-button
	  size="lg"
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('oracle')"
	  >
	  <span class="link-ref-text">Oracle aconex Link</span>
	</b-button>
      </b-col>
      <b-col cols="12" lg="4">
	<b-button
	  size="lg"
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('addon')"
	  >	  
	  <span class="link-ref-text">Add-on to TrinApp CDE</span>
	</b-button>
      </b-col>
    </b-row>
  </b-container>



	<VideoSection 
		title="vimeo-crosslink-demo" 
		src="https://player.vimeo.com/video/559730100"
	/>
  
  

  <b-container
    class="bg-white d-flex section"
    fluid
    >
    <b-row class="justify-content-center align-self-center mx-auto">
      <b-col cols="12" lg="8">
	<div class="py-5 p-sm-5 p-md-3 p-lg-0">
	  <h2 class="text-center d-none d-sm-block">Do you sometimes feel like having to be a computer geek rather than a Construction professional to navigate your construction documents?</h2>
		<h3 class="text-center font-italic d-block d-sm-none">Do you sometimes feel like having to be a computer geek rather than a Construction professional to navigate your construction documents?</h3>
	</div>
	<div class="p-lg-5 pb-5">
	  <p>Are you frustrated that Construction and Architecture applications operating in silos create PDF files of your Drawings and Specs without linking them?</p>
	  <p>Are you tired of wasting a massive amount of time having to navigate from one Drawing or Spec to another by manually searching for every referenced document you need to read?</p>
	</div>
      </b-col>
    </b-row>
  </b-container>
  
  
  <div ref="unique" />
  <SectionDivider bg-color="#ffb300" />
  
  
  
  <Layout02>
    <div slot="icon">
      <b-img
	:src="require('../assets/trinity_construction.png')"
	class="py-6"
	style="width: 100px;"
	/>
    </div>
    <div slot="header">So hard only Graphmetrix does it well!</div>
    <div slot="description">
      <div
	class="m-auto text-left"
	style="max-width: 640px;"
	>
	<p>Only we (and our partners using our technology) are able to use AI to find and link up page links in construction Drawings with a high success rate.</p>
	<p>Thanks to Trinity, our unique Conceptual computing AI combined with some scanning magic, you will be able to automatically and quickly create clickable hyperlinks between thousands of Drawings and Specs.</p>
	<p>Are we proud of that? Sure, but what matters to you is that it is available to you right now, and it will save you and your team lots of time.</p>
      </div>
    </div>
    <div slot="button">
      <b-button size="lg" class="btn-orange my-5" href="https://trinpod.us/pricing?industry=construction">Get Started</b-button>
    </div>
  </Layout02>
  
  <b-container
    class="px-5 text-center"
    style="background-color: #08034c;"
    fluid
    >
    <b-row>
      <b-col
	cols="12"
	md="7"
	lg="4"
	offset-lg="2"
	class="p-1"
	>
	<figure>
	  <b-img
	    :src="require('../assets/Porsche-specs2-lnk-3.png')"
	    fluid
	    />
	</figure>
      </b-col>
      <b-col
	cols="12"
	md="5"
	lg="4"
	class="p-1"
	>
	<figure>
	  <b-img
	    :src="require('../assets/Porsche-dwgs2-lnk-7-crop.png')"
	    fluid
	    />
	</figure>
      </b-col>
      <b-col
	cols="12"
	class="pt-1 px-1 pb-5 mb-5"
	>
	<figure>
	  <b-img
	    :src="require('../assets/Porsche-dwgs2-lnk-21-crop.png')"
	    fluid
	    />
	</figure>
      </b-col>
    </b-row>
  </b-container>
  
  
  
  <SectionDivider bg-color="#ffb300" />
  
  
  
  <b-container
    class="bg-white d-flex section"
    fluid
    >
    <b-row class="justify-content-center align-self-center mx-auto">
      <b-col cols="12" lg="6">
	<div class="p-5 p-lg-0">
	  <h2 class="text-center">When you are reading a construction drawing and you need to navigate to a referenced page link, we understand that you want it to be easy and instant.</h2>
	</div>
      </b-col>
    </b-row>
  </b-container>



  <b-container
    class="bg-white d-flex section border-top border-muted"
    fluid
    >
    <b-row class="m-auto text-center justify-content-center">
      <b-col
	cols="12"
	md="8"
	>
	<b-container class="py-5 px-0" fluid>
	  <b-row>
	    <b-col>
	      <h1>Automated extraction of key metadata from your Drawings & Specs</h1>
	    </b-col>
	  </b-row>
	  <b-row>
	    <b-col class="py-4">
	      <b-img
		:src="require('../assets/trinapp_crosslink.png')"
		style="width: 170px;"
		/>
	    </b-col>
	  </b-row>
	  <b-row class="m-auto justify-content-center">
	    <b-col
	      cols="12"
	      lg="8"
	      class="px-0"
	      >
	      <div class="mx-lg-auto text-left">
		<p>Save time, lots of time, by having Trinity extract and publish:
		  <br><span class="font-weight-bold">Drawings:</span> Sheet Number, Sheet Title, Discipline, Revision Date, and Revision Reason.

		  <br><span class="font-weight-bold">Specs:</span> Section Name and Section Number. </p>

		<p>Capable of processing thousands of sheets in one go.</p>

		<p>Our learning focus optimized OCR (Patent Pending) system enables high quality data capture from construction based raster PDFs and images.</p>
	      </div>
	    </b-col>
	  </b-row>
	</b-container>
      </b-col>
    </b-row>
  </b-container>
  
  
  
  <b-container
    class="bg-light d-flex section"
    fluid
    >
    <b-row class="m-auto text-center justify-content-center">
      <b-col
	cols="12"
	md="10"
	>
	<div class="py-5">
	  <h1 class="text-center red">Review Web Application</h1>
	</div>
	<b-container
	  class="py-5"
	  fluid
	  >    
	  <b-row>
	    <b-col
	      cols="12"
	      lg="6"
	      >
	      <div class="d-inline-block text-left">
		<div class="d-flex mb-2">
		  <font-awesome-icon :icon="faCheck" class="mr-2 mt-1 mb-auto" style="color: #ffb300" />
		  <p>Notifies the user via email when a set or spec is ready for review</p>
		</div>
		<div class="d-flex mb-2">
		  <font-awesome-icon :icon="faCheck" class="mr-2 mt-1 mb-auto" style="color: #ffb300" />
		  <p>Provides easy to read highlighted enlargements of meta-data discovered for fast review by customers</p>
		</div>
		<div class="d-flex mb-2">
		  <font-awesome-icon :icon="faCheck" class="mr-2 mt-1 mb-auto" style="color: #ffb300" />
		  <p>Enables user to make any needed changes prior to final publishing to the document management system</p>
		</div>
	      </div>
	    </b-col>
	    <b-col
	      cols="12"
	      lg="6"
	      class="m-auto"
	      >
	      <b-img :src="require('../assets/review_meta.png')" fluid class="border" />
	    </b-col>
	  </b-row>
	  <b-row>
	    <b-col>
	      <b-button
		size="lg"
		class="btn-orange my-5"
		href="https://trinpod.us/pricing?industry=construction"
		>
		Get Started
	      </b-button>
	    </b-col>
	  </b-row>
	</b-container>
      </b-col>
    </b-row>
  </b-container>
  
  
  
  <div ref="oracle" />
  <b-container
    class="bg-white d-flex section"
    fluid
    >
    <b-row class="m-auto text-center justify-content-center">
      <b-col
	cols="12"
	md="10"
	>
	<b-container class="py-5" fluid>
	  <b-row>
	    <b-col>
	      <h1 class="red">Oracle aconex Link</h1>
	    </b-col>
	  </b-row>
	  <b-row>
	    <b-col class="py-4">
	      <b-img
		:src="require('../assets/trinapp-aconex.png')"
		style="width: 170px;"
		/>
	    </b-col>
	  </b-row>
	  <b-row>
	    <b-col>
	      <div class="mx-auto text-left" style="max-width: 680px;">
		<p><span class="red">Crosslink</span> has an <span class="red">Oracle aconex Link</span> for aconex users.</p>
		<p>Trinity Crosslink creates the links for you and extracts the metadata. Oracle aconex Link automates the tedious job of entering the metadata for each sheet uploaded to Oracle aconex.</p>
		<p>With Oracle aconex Link, you can upload your Drawings and Specs 6950% faster than the closest AI "competitor."</p>
	      </div>
	    </b-col>
	  </b-row>
	  <b-row>
	    <b-col>
	      <b-button
		size="lg"
		class="btn-yellow my-5"
		to="/construction/trinpod/aconex"
		@click.native="scrollToTop()"
		>
		Oracle aconex Link
	      </b-button>
	    </b-col>
	  </b-row>
	</b-container>
      </b-col>
    </b-row>
  </b-container>


  <div ref="addon" />
  <SectionDivider bg-color="#ffb300" />



  <GetBundle />



  <SectionDivider bg-color="#ffb300" />
  
  
  
  <GmxFooter />  
</div>
</template>

<script>
import GmxFooter from '@/components/footer.vue';
import Banner from '@/components/gmx-banner.vue';
import SectionDivider from '@/components/section-divider.vue';
import VideoSection from '@/components/video-section.vue';
import Layout02 from '@/components/layout-02.vue';
import Layout09 from '@/components/layout-09.vue';
import GetBundle from '@/components/get-bundle.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
export default {
    name: "ConstructionCrosslink",
    components: {
	Banner,
	GmxFooter,
	SectionDivider,
	VideoSection,
	Layout02,
	Layout09,
	GetBundle,
	FontAwesomeIcon
    },
    data () {
	return {
	    faCheck
	}
    },
    mounted () {
	window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
	window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
	img: function (image) {
	    require(image)
	},
	onScroll: function () {
	    // Get the current scroll position
	    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
	    if (currentScrollPosition < 0) {
		return
	    }
	    // Stop executing this function if the difference between
	    // current scroll position and last scroll position is less than some offset
	    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
		return
	    }
	    this.showVerticalRight = currentScrollPosition < this.lastScrollPosition
	    this.showNavbarLogo = currentScrollPosition > this.lastScrollPosition
	    this.lastScrollPosition = currentScrollPosition
	},
	goto: function (refName) {
    	    var element = this.$refs[refName];
	    //log.debug(element);
	    var top = element.offsetTop;
      
	    window.scrollTo(0, top);
	},
	scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>
